export const EntitySelectorEntity = Object.freeze({
	Deal: 'deal',
	Resource: 'resource',
	Room: 'room',
	User: 'user',
	ResourceType: 'resource-type',
	Product: 'product',
});
